var exports = {
  "j": "xe533113f--04764c--cont",
};

module.exports = exports;
